import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { loginProviders, withLogin } from '@softapps/allgemein/login';
import { moduleProviders } from '@softapps/allgemein/modules';
import { passwordProviders } from '@softapps/allgemein/password';
import {
  accountContextProviders,
  contextSettingsProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders,
} from '@softapps/allgemein/utils';
import {
  provideSoftApps,
  SOFTLINE_ROUTES_APPS,
  SOFTLINE_ROUTES_PUBLIC,
} from '@softapps/core';
import { provideConstructionPartsModule } from '@softapps/gewerbe/construction-parts';
import { artikelvorratProviders } from '@softapps/mde/artikelvorrat';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { inventurProviders } from '@softapps/mde/inventur';
import { materiallieferscheinScanProviders } from '@softapps/mde/materiallieferschein-scan';
import { retourenProviders } from '@softapps/mde/retouren';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { wwsCoreProviders } from '@softapps/wws/core';
import { warenuebernahmeProviders } from '@softapps/wws/warenuebernahme';
import { provideDarkTheme, remoteConfigProviders } from '@softline/application';
import { environment } from '../environments/environment';
import { platform } from '../platforms/platform';
import { publicRoutes, shellRoutes } from './app.routes';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import { provideEslConfigModule } from '@softapps/handel/esl-config';
import {
  provideEslLinkStorageProviders,
  provideEslSearchProviders,
} from '@softapps/handel/esl-link-storage';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([]),
    provideSoftApps(
      { connection: environment.connection, theme: environment.theme },
      withLogin()
    ),

    provideDarkTheme(false),

    { provide: SOFTLINE_ROUTES_APPS, useValue: shellRoutes, multi: true },
    { provide: SOFTLINE_ROUTES_PUBLIC, useValue: publicRoutes, multi: true },

    /*
    importProvidersFrom(
      BrowserAnimationsModule,
      RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' }),

      // Framework
      CoreModule.forRoot(),
      StoreModule.forRoot(),
      ConnectionModule.forRoot(environment.connection),
      AuthenticationModule.forRoot(),
      JwtAuthenticationModule.forRoot(),
      ApplicationModule.forRoot(),
      AppearanceModule.forRoot({
        defaultSettings: { theme: environment.theme } }),
      DynamicModule.forRoot(),
      MasterDataModule.forRoot(),
      DeveloperModule.forRoot(),
      ConsoleModule.forRoot(),
      ItemScanModule.forRoot(),
      OfflineModule.forRoot(),
      SoftappsCoreModule.forRoot()
    ),*/

    // Allgemein
    ...utilitiesProviders,
    ...contextSettingsProviders,
    ...userContextProviders,
    ...accountContextProviders,

    /*
    ...notificationProviders,
    ...sendNotificationProviders,
     */

    ...settingsProviders,
    ...remoteConfigProviders,
    ...passwordProviders,
    ...loginProviders,
    ...moduleProviders,
    ...provideConstructionPartsModule(),

    // ...gesamtabfrageProviders,

    // MDE
    ...wwsCoreProviders,

    ...artikelvorratProviders,
    ...artikelInfoProviders,
    ...bestellerfassungProviders,
    ...bestellvorschlagProviders,
    ...etikettendruckProviders,
    ...inventurProviders,
    ...materiallieferscheinScanProviders,
    ...retourenProviders,
    ...warenverprobungProviders,
    ...warenuebernahmeProviders,
    provideEslConfigModule(),
    provideEslLinkStorageProviders({ storageSelection: true }),
    provideEslSearchProviders(),
    ...provideStorageLocation(),

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
